class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );


    /* Personalizados */

    this.lineItemStatusElement =
    document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems') || document.getElementById('cart-notification-update');
    mainCartItems.classList.add('cart__items--disabled'); //Deshabilita los productos del carrito

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`); // Toma los elementos de carga del carrito
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`); // Toma los elementos de carga del drawer 

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden')); // Remueve las clases hidden para que se vea la carga. 

    document.activeElement.blur(); // Se quita el foco del elemento activo

    console.log('Line Items Status: ', this.lineItemStatusElement);
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems') || document.getElementById('cart-notification-update');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
   
  }


  onChange(event) {
    console.log(event.target);
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId); 
  }

  updateQuantity(line, quantity, name, variantId) {  

    /*
      Line: El indice del elemento que tiene el input del contador.
      Quantity: La cantidad de productos que tiene el input. 
      Name: Si el name es del botón de Sumar o de Restar (plus - minus).
      VariatId: EL ID de la variante. 
    */

    console.log('Line:', line);
    console.log('Quantity:', quantity);
    console.log('Name:', name);
    console.log('Variant ID:', variantId);


    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: 'cart-notification-update',
      sections_url: window.location.pathname,
    });

    console.log('Cuerpo de la petición: ');
    console.log(body);

    console.log('Routes:', routes);
    /* El objeto routes, se configura desde el theme.liquid */ 
    /* En este caso se hace a /cart/change */

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } }) // fetchConfig tiene la configuración de la petición, la petición se realiza con POST, está en el global.js. 
      /* 
        A fetch se le pasa  la URL y luego la configuración que viene por:
          * method: POST,
          * headers:...
          * body:...
        fetch(url, method:..., headers: {...}, body: JSON.stringify(data))
      */
      .then((response) => {
        console.log('Respuesta: ', response); // Da la respuesta de la petición.
        return response.text();
      })
      .then((state) => {
       
        const parsedState = JSON.parse(state);

        console.log('Estado: ', parsedState);

     
       
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }



  /* -------------- */

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {

    console.log('PARSED STATE:', parsedState);
    console.log('PARSED STATE KEY:', parsedState.key);

    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      console.log(section);
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getCartProductCount(parsedState){
    let productCount = parsedState.sections['cart-notification-button'];

    if (productCount) {
      const number = productCount.match(/\d+/g).toString();   
      let cartNotificationInfo = document.getElementById('cart-notification-info');
      const cartNotificationButton = document.getElementById('cart-notification-button');
      if(cartNotificationInfo && cartNotificationButton){
        cartNotificationInfo.textContent = `Tienes ${number} productos en tu carrito`;
        cartNotificationButton.textContent = 'IR AL CARRITO';
      }     
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },            
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
